import { BasicCrudService } from '@/app/common/utils/crud/basic-crud.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User, UserCreateParams, UserFindAllParams } from './type';
import { UserApiService } from '../infra/api.service';

@Injectable({ providedIn: 'root', useClass: UserApiService })
export abstract class UserService extends BasicCrudService<
  User,
  User['id'],
  UserFindAllParams,
  User,
  UserCreateParams
> {
  abstract setActive(id: User['id'], isActive: boolean): Observable<void>;
}
